import {RouteStack} from './store/route-stack.model';

export interface AppState {
  unhandledRoute: boolean;
  waitingPayment: boolean;
  paymentData: object;
  RouteStack: RouteStack[];
}

export const initializeState = (): AppState => {
  return ({
    RouteStack: [],
    unhandledRoute: false,
    waitingPayment: false,
    paymentData: null
  });
};
